import { createSlice } from "@reduxjs/toolkit";
import { fetchInventoryDispatch } from "./thunk";

interface StateType {
  dispatchList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: StateType = {
  dispatchList: [],
  rowCount: 0,
  loading: false,
  error: null,
};

const inventoryDispatchSlice = createSlice({
  name: "inventoryDispatch",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchInventoryDispatch.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchInventoryDispatch.fulfilled, (state, action) => {
        state.loading = false;
        state.dispatchList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchInventoryDispatch.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch Dispatch List";
      });
  },
});

export default inventoryDispatchSlice.reducer;
